import React, { useEffect } from "react";

// Components
import Can from "components/Common/Can/Can";

// Styles
import MenuItemContainer from "./MenuItem.styles";

//Utils
import { formatstringforTests } from "utils/common.utils";
import { useSettings } from "context/Settings.context";

type Props = {
    id?: string;
    click: Function;
    text: string;
    icon: React.ReactNode;
    permissions: string[];
    isActive?: Boolean;
    development?: boolean;
    menuPage?: string;
};

export default function MenuItem({
    id,
    click,
    text,
    icon,
    permissions,
    isActive,
    development,
    menuPage,
}: Props) {
    const { setHoverMenuPage, hoverMenuClearTimeoutRef, hoverMenuPage } =
        useSettings();

    const isDevelopment = development
        ? process.env.REACT_APP_GIM_ENVIRONMENT === "development"
        : false;

    const handleMouseEnter = () => {
        if (menuPage) {
            // Clear any pending timeout
            if (hoverMenuClearTimeoutRef.current) {
                clearTimeout(hoverMenuClearTimeoutRef.current);
                hoverMenuClearTimeoutRef.current = null;
            }
            setHoverMenuPage(menuPage);
        }
    };

    const handleMouseLeave = () => {
        // Delay clearing to allow user to move to submenu
        if (menuPage) {
            hoverMenuClearTimeoutRef.current = setTimeout(() => {
                setHoverMenuPage(null);
                hoverMenuClearTimeoutRef.current = null;
            }, 200);
        }
    };

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            if (hoverMenuClearTimeoutRef.current) {
                clearTimeout(hoverMenuClearTimeoutRef.current);
            }
        };
    }, []);

    return (
        <>
            {isDevelopment || !development ? (
                <Can
                    yes={
                        <MenuItemContainer
                            id={id}
                            onClick={(e) => click(e)}
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                            className={
                                (
                                    hoverMenuPage
                                        ? hoverMenuPage === menuPage
                                        : isActive
                                )
                                    ? "menuItem active"
                                    : "menuItem"
                            }
                        >
                            <div
                                data-cy={`menu-nav-icon-${formatstringforTests(
                                    text
                                )}`}
                                className="iconContainer"
                            >
                                {icon}
                                <p className="menuItemText">{text}</p>
                            </div>
                        </MenuItemContainer>
                    }
                    permissions={permissions}
                />
            ) : null}
        </>
    );
}
